import { da, de, en, es, fi, fr, it, nb, nl, pl, PluralCategory, sv } from 'make-plural/plurals';

type PluralFn = (n: number | string, ord?: boolean) => PluralCategory;

const PLURALS = {
  da,
  de,
  en,
  es,
  fi,
  fr,
  it,
  nb,
  nl,
  pl,
  sv,
};

// This utility function is intended to be used for LinguiJS initialization
const getPlurals = (locale: string): PluralFn => {
  const lang = locale.split('-')[0];
  return PLURALS[lang] || PLURALS.en;
};

export default getPlurals;
